<template>
  <Transition
    enter-active-class="transition-opacity duration-300"
    leave-active-class="transition-opacity duration-300"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      id="modal-loading"
      v-if="isLoading"
      class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]"
    >
      <div class="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-xl flex items-center gap-4">
        <div class="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <span class="text-lg font-medium text-gray-900 dark:text-white">Loading...</span>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useLoadingStore } from '../../../stores/loading'

const { isLoading } = storeToRefs(useLoadingStore())
</script>